var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCrossedEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(3, 3)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.526 16.697c2.128-1.67 3.308-3.623 3.631-4.201a.99.99 0 0 0-.036-1.025 17.842 17.842 0 0 0-3.399-3.785C17.85 6.131 15.23 4.666 12 4.666c-1.384 0-2.657.27-3.806.7l1.05 1.05A9.385 9.385 0 0 1 12 6c2.812 0 5.139 1.273 6.87 2.712a16.663 16.663 0 0 1 3.02 3.315 13.462 13.462 0 0 1-3.315 3.72l.951.95Zm-3.661-3.661a4.005 4.005 0 0 0-4.9-4.9l4.9 4.9ZM9.172 9.171l5.657 5.657a4 4 0 0 1-5.657-5.657ZM7.258 7.257c-.785.427-1.496.93-2.127 1.455a16.663 16.663 0 0 0-3.02 3.315C2.899 13.359 6.075 18 12.002 18c1.89 0 3.5-.472 4.841-1.158l.987.987A11.822 11.822 0 0 1 12 19.333c-7.029 0-10.56-5.767-11.157-6.837A.99.99 0 0 1 .88 11.47a17.838 17.838 0 0 1 3.399-3.785 14.832 14.832 0 0 1 2-1.407l.979.978Z",
  fill: "#830051"
}), /*#__PURE__*/React.createElement("line", {
  x1: 1.51863,
  y1: 2.80608,
  x2: 20.3257,
  y2: 21.6132,
  stroke: "#830051",
  strokeWidth: 2
}))));

export default SvgCrossedEye;